import { LitElement, html, css } from 'lit';

class ConfirmationDivide extends LitElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }
  static styles = css`
    .confirmation-divide {
      display: flex;
      justify-content: center;
    }
  `
  render() {
    return html`
      <div class="confirmation-divide">
        <svg width="60" height="7" viewBox="0 0 60 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="3" cy="3.39819" r="3" fill="#263238"/>
          <circle cx="21" cy="3.39819" r="3" fill="#EBAE1D"/>
          <circle cx="39" cy="3.39819" r="3" fill="#91CAC4"/>
          <circle cx="57" cy="3.39819" r="3" fill="#A8ABA6"/>
        </svg>
      </div>
    `;
  }
}
if (!customElements.get('confirmation-divide'))
customElements.define('confirmation-divide', ConfirmationDivide);
